import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Moment from 'moment';
import "moment/locale/ko";
import { LogoDev } from "@mui/icons-material";

function LossDetailModal({ title, onClose, id, originRows, handleView, MenuDeleteYN }) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [originLotRows, setOriginLotRows] = useState([]);
  const [lotRows, setLotRows] = useState([]);
  const [updateLotRows, setUpdateLotRows] = useState([]);
  const [lotColumns, setLotColumns] = useState([]);
  const [fileRows, setFileRows] = useState([]);
  const [originFileRows, setOriginFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    loss_id: null,
    loss_number: '',
    loss_date: '',
    loss_approval_user_id: null,
    loss_approval_user_name: '',
    loss_reason: ''
  });
  
  // 폐기관리, 분실관리은 삭제로 updateFlag를 체크함.
  const [updateFlag, setUpdateFlag] = useState(MenuDeleteYN === 'Y' && originRows.some(row =>
    [row.loss_approval_user_id, row.reg_user_id, row.update_user_id].includes(Number(localStorage.getItem('user_id')))
  ));
  
  const handleInitSelect = () => {
    setUpdateLotRows([]);
    setUpdateFileRows([]);
    
    setInputs({
      loss_id: Number(originRows[0].loss_id),
      loss_number: originRows[0].loss_number,
      loss_date: originRows[0].loss_date,
      loss_approval_user_id: Number(originRows[0].loss_approval_user_id),
      loss_approval_user_name: originRows[0].loss_approval_user_name,
      loss_reason: originRows[0].loss_reason
    });

    var lotData = originRows.filter((item, index) => {
      return (
        originRows.findIndex((item2, index2) => {
          return typeof item.lot_loss_item_lot_seq !== 'undefined' && item.lot_loss_item_lot_seq === item2.lot_loss_item_lot_seq;
        }) === index
      );
    });
    
    lotData = lotData.sort(function(a, b) { 
      return a.lot_loss_item_lotno < b.lot_loss_item_lotno ? -1 : a.lot_loss_item_lotno > b.lot_loss_item_lotno ? 1 : 0;
    });

    setLotRows(lotData.map((item, index) => ({
      id: item.lot_loss_item_lot_seq,
      lot_no: item.lot_loss_item_lotno,
      lot_loss_item_id: item.lot_loss_item_id,
      lot_loss_item_name: item.lot_loss_item_name,
      lot_loss_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.lot_loss_item_spec, item.lot_loss_item_width, item.lot_loss_item_depth, item.lot_loss_item_height),
      lot_loss_save_workplace_id: item.lot_loss_save_workplace_id,
      lot_loss_save_workplace_name: item.lot_loss_save_workplace_name,
      lot_loss_save_warehouse_id: item.lot_loss_save_warehouse_id,
      lot_loss_save_warehouse_name: item.lot_loss_save_warehouse_name,
      lot_loss_save_section_id: item.lot_loss_save_section_id,
      lot_loss_save_section_name: item.lot_loss_save_section_name,
      row_type: 'O',
      update_type: 'N'
    })));

    setOriginLotRows(lotData.map((item, index) => ({
      id: item.lot_loss_item_lot_seq,
      lot_no: item.lot_loss_item_lotno,
      lot_loss_item_lot_type: item.lot_loss_item_lot_type,
      lot_loss_item_lot_type_name: item.lot_loss_item_lot_type_name,
      lot_loss_item_id: item.lot_loss_item_id,
      lot_loss_item_name: item.lot_loss_item_name,
      lot_loss_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.lot_loss_item_spec, item.lot_loss_item_width, item.lot_loss_item_depth, item.lot_loss_item_height),
      lot_loss_save_workplace_id: item.lot_loss_save_workplace_id,
      lot_loss_save_workplace_name: item.lot_loss_save_workplace_name,
      lot_loss_save_warehouse_id: item.lot_loss_save_warehouse_id,
      lot_loss_save_warehouse_name: item.lot_loss_save_warehouse_name,
      lot_loss_save_section_id: item.lot_loss_save_section_id,
      lot_loss_save_section_name: item.lot_loss_save_section_name,
      row_type: 'O',
      update_type: 'N'
    })));

    setUpdateLotRows(lotData.map((item, index) => ({
      id: item.lot_loss_item_lot_seq,
      lot_no: item.lot_loss_item_lotno,
      lot_loss_item_lot_type: item.lot_loss_item_lot_type,
      lot_loss_item_lot_type_name: item.lot_loss_item_lot_type_name,
      lot_loss_item_id: item.lot_loss_item_id,
      lot_loss_item_name: item.lot_loss_item_name,
      lot_loss_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.lot_loss_item_spec, item.lot_loss_item_width, item.lot_loss_item_depth, item.lot_loss_item_height),
      lot_loss_save_workplace_id: item.lot_loss_save_workplace_id,
      lot_loss_save_workplace_name: item.lot_loss_save_workplace_name,
      lot_loss_save_warehouse_id: item.lot_loss_save_warehouse_id,
      lot_loss_save_warehouse_name: item.lot_loss_save_warehouse_name,
      lot_loss_save_section_id: item.lot_loss_save_section_id,
      lot_loss_save_section_name: item.lot_loss_save_section_name,
      row_type: 'O',
      update_type: 'N'
    })));

    var fileData = originRows.filter((item, index) => {
      return (
        originRows.findIndex((item2, index2) => {
          return typeof item.loss_file_id !== 'undefined' && item.loss_file_id === item2.loss_file_id;
        }) === index
      );
    });

    setFileRows(fileData.map((item, index) => ({
      id: item.loss_file_id,
      file_name_sever: item.loss_file_name_sever,
      file_size: item.loss_file_size,
      file_type: item.loss_file_type,
      file_extension: item.loss_file_extension,
      file_name: item.loss_file_name,
      file_type_name: item.loss_file_type_name,
      file_size_dp: item.loss_file_size_dp,
      reg_user_name: item.loss_file_user_name,
      reg_datetime: Moment(item.loss_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
      row_type: 'O',
      update_type: 'N'
    })));

    setOriginFileRows(fileData.map((item, index) => ({
      id: item.loss_file_id,
      file_name_sever: item.loss_file_name_sever,
      file_size: item.loss_file_size,
      file_type: item.loss_file_type,
      file_extension: item.loss_file_extension,
      file_name: item.loss_file_name,
      file_type_name: item.loss_file_type_name,
      file_size_dp: item.loss_file_size_dp,
      reg_user_name: item.loss_file_user_name,
      reg_datetime: Moment(item.loss_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
      row_type: 'O',
      update_type: 'N'
    })));
  };

  const handleSetting = () => {
    
    setLotColumns([
      {
          field: 'actions',
          headerName: '취소',
          width: 55,
          type:'actions',
          disableClickEventBubbling: true,
          getActions: (params) => [
              <GridActionsCellItem icon={<DeleteIcon color={ MenuDeleteYN === "Y" ? "error" : "grey"} />} onClick={() => {DeleteClick(params)}} label="Delete" disabled={ MenuDeleteYN === "Y" ? false : true } />
          ],
          headerAlign: 'center', 
          align:'center'
      } ,
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'lot_no', headerName: 'LotNo', width: 160, headerAlign: 'center', align:'center' },
      { field: 'lot_loss_item_id', headerName: '품목ID', width: 0, headerAlign: 'center', align:'left' },
      { field: 'lot_loss_item_name', headerName: '품목', width: 120, headerAlign: 'center', align:'left' },
      { field: 'lot_loss_item_spec', headerName: '규격', width: 160, headerAlign: 'center', align:'left' },
      { field: 'lot_loss_save_workplace_id', headerName: 'lot_loss_save_workplace_id',width: 0, headerAlign: 'center'},
      { field: 'lot_loss_save_workplace_name', headerName: '사업장',width: 130, headerAlign: 'center'},
      { field: 'lot_loss_save_warehouse_id', headerName: 'lot_loss_save_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'lot_loss_save_warehouse_name', headerName: '창고', width: 130, headerAlign: 'center', align:'left' },
      { field: 'lot_loss_save_section_id', headerName: 'lot_loss_save_section_id',width: 0, headerAlign: 'center'},
      { field: 'lot_loss_save_section_name', headerName: '구역',width: 130, headerAlign: 'center', align:'left'},
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' }
    ]);

    setFileColumns([
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 320, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 120, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);
    
    setLotColumnVisibilityModel ({
      id: false,
      lot_no: true,
      actions: updateFlag,
      lot_loss_item_id: false,
      lot_loss_item_name: true,
      lot_loss_item_spec: true,
      lot_loss_save_workplace_id: false,
      lot_loss_save_workplace_name: true,
      lot_loss_save_warehouse_id: false,
      lot_loss_save_warehouse_name: true,
      lot_loss_save_section_id: false,
      lot_loss_save_section_name: true,
      row_type: false,
      update_type: false
    })

    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      actions: updateFlag,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [lotColumnVisibilityModel, setLotColumnVisibilityModel] = useState({
    id: false,
    lot_no: true,
    actions: updateFlag,
    lot_loss_item_id: false,
    lot_loss_item_name: true,
    lot_loss_item_spec: true,
    lot_loss_save_workplace_id: false,
    lot_loss_save_workplace_name: true,
    lot_loss_save_warehouse_id: false,
    lot_loss_save_warehouse_name: true,
    lot_loss_save_section_id: false,
    lot_loss_save_section_name: true,
    row_type: false,
    update_type: false
  });
  
  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: updateFlag,
    download: true,
    row_type: false,
    update_type: false
  });

  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    handleSetting();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);

  useEffect(() => {
    handleInitSelect();
  }, [originRows]);
  
  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const DeleteClick = (object) => {
    var lotData = originRows.filter((item, index) => {
      return (
        originRows.findIndex((item2, index2) => {
          return typeof item.lot_loss_item_lot_seq !== 'undefined' && item.lot_loss_item_lot_seq === item2.lot_loss_item_lot_seq;
        }) === index
      );
    });

    if(lotData.length === 1){
      Swal.fire({
        title: '분실번호 '+lotData[0].loss_number+' 삭제',
        html : '분실번호의 마지막 LotNo이므로 분실번호가 삭제 됩니다.<br/>분실번호 '+lotData[0].loss_number+'을(를) <span style="color:red; font-weight:bold;">삭제</span> 하시겠습니까?<br/>삭제하시면 복구 할 수 없습니다.',
        showCancelButton : true,
        confirmButtonColor : "#d33",
        confirmButtonText : "삭제",
        cancelButtonText : "닫기"
      }).then((result) => {
        if (result.isConfirmed) {
          if (appStore.loading) return;
          appStore.setLoading(true);

          axios.post('/api/p/Loss/Delete', new URLSearchParams({
              delete_loss_id: lotData[0].loss_id,
              folder: 'Loss'
          }),
          { withCredentials: true })
          .then(function (response) {
            if(response.status === 200){
              Swal.fire({
                  title: '분실번호 '+lotData[0].loss_number+' 삭제 완료',
                  text: '정상적으로 분실번호 '+lotData[0].loss_number+'가 삭제 되었습니다.',
                  confirmButtonText: '확인',
                  timer: 5000,
                  timerProgressBar: true
              }).then((result) => {
                  handleView();
                  onClose?.();
              });
            }else{
                appStore.capture();
            }
          })
          .catch(function (error) {
            appStore.capture();
          })
          .finally(() => {
            appStore.setLoading(false); 
          });
        }
      });
    }else{
      Swal.fire({
        title: object.row.lot_no+' 분실 취소',
        html : 'LotNo '+object.row.lot_no+'을(를) <span style="color:red; font-weight:bold;">취소</span> 하시겠습니까?<br/>취소하시면 복구 할 수 없습니다.',
        showCancelButton : true,
        confirmButtonColor : "#d33",
        confirmButtonText : "취소",
        cancelButtonText : "닫기"
      }).then((result) => {
        if (result.isConfirmed) {
          if (appStore.loading) return;
          appStore.setLoading(true);

          axios.post('/api/p/Loss/LossLotDelete', new URLSearchParams({
              delete_loss_id: lotData[0].loss_id,
              delete_loss_lotno: object.row.lot_no
          }),
          { withCredentials: true })
          .then(function (response) {
            if(response.status === 200){
                Swal.fire({
                  title: 'LotNo 분실 취소',
                  text: '정상적으로 LotNo가 분실 취소 되었습니다.',
                  confirmButtonText: '확인',
                  timer:5000,
                  timerProgressBar: true
                }).then((result) => {
                  handleView();
                });
            }else{
                appStore.capture(response.request.responseURL);
            }
          })
          .catch(function (error) {
              appStore.capture();
          })
          .finally(() => {
            appStore.setLoading(false); 
          });
        }
      });
    }
  };

  const fileDownloadClick = (object) => {
    //파일 다운로드
    axios.post('/api/SaveCommon/FileDownload', new URLSearchParams({
      fileName: object.row.file_name,
      fileNameSever: object.row.file_name_sever
    }),
    { withCredentials: true, responseType: 'blob' })
    .then(function (response) {
        if(response.status === 200){
          const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", object.row.file_name);
					document.body.appendChild(link);
					link.click();
        }else{
          appStore.capture();
        }
    })
    .catch(function (error) {
        appStore.capture();
        console.log("네트워크 실패", error);
    })
  };
  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={tabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="분실 정보" value="1" />
                <Tab label="분실 Lot" value="2" />
                <Tab label="분실 파일" value="3" />
              </TabList>
            </Box>
            <TabPanel value="1" ref={tabPanelRef}>
              <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title" style={ {  } }>분실번호</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '190px' } }>
                          <input type="text" placeholder="분실번호" value={inputs.loss_number} name="loss_number" autoComplete="off" disabled={true}  style={ { fontWeight:'bold', color: 'black' } } readOnly />
                        </div>
                        <div className="modal_filed_title" style={ { paddingLeft: '20px', width: '100px' } }>분실일자</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '150px' } }>
                          <input type="date" placeholder="분실일자" value={inputs.loss_date} name="loss_date" autoComplete="off" style={{backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' }} readOnly />
                        </div>
                        <div className="modal_filed_title" style={ { paddingLeft: '30px', width: '106px' } }>분실승인자</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '170px' } }>
                          <input type="text" placeholder="분실승인자" value={inputs.loss_approval_user_name} name="loss_approval_user_name" autoComplete="off" style={{backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black' }} readOnly />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">분실사유</div>
                        <div className="modal_filed_input">
                          <textarea placeholder="분실사유" name="loss_reason" value={inputs.loss_reason} style={{width: '768px', height: '200px', marginTop:'10px', border:'2px lightgrey solid', borderRadius: '5px', fontSize:'17px', fontFamily:'none', resize:'none', backgroundColor: '#EFEFEF4D'}} autoComplete="off" readOnly>
                          </textarea>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={lotRows}
                  columns={lotColumns}
                  columnVisibilityModel={lotColumnVisibilityModel}
                  editMode='cell'
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="3" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell' 
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </PCModal>
  );
}

export default LossDetailModal;